import { useEffect, useState } from 'react';

interface ConnectivityState {
  isOnline: boolean;
  lastOfflineAt: number | null;
  lastOnlineAt: number | null;
}

function getInitialOnlineState(): boolean {
  if (typeof navigator === 'undefined') {
    return true;
  }
  return navigator.onLine;
}

export function useConnectivity(): ConnectivityState {
  const [state, setState] = useState<ConnectivityState>(() => ({
    isOnline: getInitialOnlineState(),
    lastOfflineAt: null,
    lastOnlineAt: null,
  }));

  useEffect(() => {
    const handleOnline = () => {
      setState((current) => ({
        isOnline: true,
        lastOfflineAt: current.lastOfflineAt,
        lastOnlineAt: Date.now(),
      }));
    };

    const handleOffline = () => {
      setState((current) => ({
        isOnline: false,
        lastOfflineAt: Date.now(),
        lastOnlineAt: current.lastOnlineAt,
      }));
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return state;
}
